export function downloadFile(response) {
    try {
        const a = document.createElement('a')
        const objectUrl = window.URL.createObjectURL(response.data)
        a.href = objectUrl
        a.download = decodeURIComponent(response.headers['content-disposition'].replace('attachment;filename=', '').replace(/\+/g, ' '))
        a.style.display = 'none'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        window.URL.revokeObjectURL(objectUrl)
    } catch (e) {
        console.log(e)
    }
}
export function openFile(data) {
    try {
        var file = new Blob([data], { type: data.type })
        var fileURL = URL.createObjectURL(file)
        window.open(fileURL)
    } catch (e) {
        console.log(e)
    }
}
export function downloadBlobFile(blob, filename) {
    const a = document.createElement('a')
    const objectUrl = window.URL.createObjectURL(blob)
    a.href = objectUrl
    a.download = filename
    a.click()
    window.URL.revokeObjectURL(objectUrl)
}

export function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[arr.length - 1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], filename, { type: mime })
}